import React from "react";
import { Field } from "redux-form";
import { required } from "../../../../../utils/formValidators";
import { renderSelectField } from "../../../../../utils/renderField";

export const RecurringFrequency = (props) => {
  return (
    <div>
      <div className="mb-1 bold f18">Choose Payment Frequency</div>
      <div className="mb-4">How often would you like to make a payment?</div>
      <div className="mb-3">
        <Field
          id="PaymentFrequency"
          name="PaymentFrequency"
          component={renderSelectField}
          options={["Monthly", "Bi-Weekly", "Weekly"]}
          validate={[required]}
          type="text"
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/recurring-fields/recurring-frequency.component.js